import { UILayer } from "../../../CommonUI/BuildlingBlocks/UILayer";
import { FlowConfiguration } from "../../../rule-engine-core/Flow/FlowConfiguration";
import { MappingBuilder } from "../../../Mapping/MappingBuilder";

export function FlowMappingLayer(props: { flow: FlowConfiguration; open: boolean; onComplete: () => void }) {
    return (
        <UILayer
            onClose={props.onComplete}
            open={props.open}
            fullScreen={true}
            renderUI={() => {
                return (
                    <MappingBuilder
                        onSave={props.onComplete}
                        onCancel={props.onComplete}
                        definition={props.flow.outputMapping}
                    />
                );
            }}
        ></UILayer>
    );
}
